import { PermissionsConjunction } from 'frontend-container/components/Menu/authorization/types';
import { MenuElement } from 'frontend-container/components/Menu/types';
import { hasAnyCroContextGuard } from 'frontend-container/components/Menu/utils/modules/centralReservationOffice';

import {
  centralReservationOfficePermissionKeys,
  GeneralSettingCode,
} from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

export const centralAvailabilityInquiryMenu: MenuElement = {
  translation: 'MENU.CENTRAL_AVAILABILITY_INQUIRY.TITLE',
  icon: IconName.calendarPeriod,
  id: 'menu-central-availability-inquiry',
  settings: [GeneralSettingCode.CentralReservationOffice],
  items: [
    {
      link: `${acConfig.newFrontendUrls.centralReservationOffice}/central-availability-inquiry`,
      code: 'CentralAvailabilityInquiry',
      aliases: [acConfig.newFrontendUrls.centralReservationOffice],
      translation: 'MENU.CENTRAL_AVAILABILITY_INQUIRY.ITEMS.DASHBOARD',
      permissionsConfiguration: {
        permissions: [
          centralReservationOfficePermissionKeys.useCentralAvailabilityInquiry,
        ],
        permissionsConjunction: PermissionsConjunction.And,
      },
      allowedWhen: hasAnyCroContextGuard,
    },
  ],
};
